// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2GWEJ","additionalInfo":"AgreementModal_additionalInfo__39x2O"};